import { GET_TTD_OTS_SEGMENT_EXPORTS_BY_ID } from '../queries';
import { RateLevel } from '../../constants';
import { useQuery } from '@apollo/client';

const useSegmentExports = ({ segmentId, rateLevel }) => {
  const { loading, error, data, refetch } = useQuery(
    GET_TTD_OTS_SEGMENT_EXPORTS_BY_ID,
    {
      variables: {
        segmentId: segmentId || '',
        rateLevel: rateLevel || RateLevel.SYSTEM,
      },
      skip: !segmentId,
      errorPolicy: 'all',
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    loading,
    error,
    segmentExports: data?.getTtdOtsSegmentExportsById || [],
    refetch,
  };
};

export default useSegmentExports;
